export const EmailType = {
  Confirmation: 0,
  PasswordReset: 1,
  PdfValidationFinished: 2,
  OrderPaymentComplete: 3,
  HotfolderCrashInfo: 4,
  Unknown: 5
}
